import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact(props) {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_9wbjwru', 'template_j5aidxm', form.current, 'kP2syY0Wn5Ti_ym5o')
      .then((result) => {
          console.log(result.text);
          console.log("Message Sent Successfully");
      }, (error) => {
          console.log(error.text);
      });
  };

  return (

    <div id='contact' className='-z-50 mt-10 bg-[#ecf0f5] md:pl-[350px] pl-8 pr-8 pt-16 pb-16 flex flex-col space-y-4 ' onMouseOver={() => props.onHover("contact")}>
      
      <h1 className='text-3xl pt-2 pl-2 font-[650] text-[#173b6c] '>Contact</h1>
      
      <hr className='relative pb-4 left-2 w-12 border-t-4 border-blue-400' />

      {/* ----------------- */}
      
      <div className='flex flex-col md:flex-row md:items-stretch items-center  justify-center space-y-10 md:space-y-0 md:space-x-10 h-full  md:p-2'>
        
        <div className='bg-white p-8 w-full space-y-6 md:w-[40%] flex-grow shadow-2xl'>

            <div className='flex flex-row space-x-4 items-center'>
                <span className=''>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="blue" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                    </svg> 
                </span>
                <div className='flex flex-col'>
                    <span className='text-2xl font-semibold'>Email : </span>
                    <span className='text-blue-400'>prathmeshnikam2002@gmail.com</span>
                </div>
            </div>

            <div className='flex flex-row space-x-4 items-center'>
                <span className=''>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="blue" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                    </svg>
                </span>
                <div className='flex flex-col'>
                    <span className='text-2xl font-semibold'>Call : </span>
                    <span className='text-blue-400'>+91-8390450882</span>
                </div>
            </div>

            <div className='flex flex-row space-x-4 items-center'>
                <span className=''>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="blue" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 9.563C9 9.252 9.252 9 9.563 9h4.874c.311 0 .563.252.563.563v4.874c0 .311-.252.563-.563.563H9.564A.562.562 0 019 14.437V9.564z" />
                    </svg>

                </span>
                <div className='flex flex-col'>
                    <span className='text-2xl font-semibold'>Linkedin : </span>
                    <span className='text-blue-400'>linkedin.com/in/pratham-nikam-217251204</span>
                </div>
            </div>

            <div>
                <iframe title='Google Maps' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.898933433305!2d77.29223145!3d19.1120892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bce29f0b2e43199%3A0xe11b84ac3144b2b4!2sSGGS%2C%20Vishnupuri%2C%20Nanded%2C%20Maharashtra%20431606!5e0!3m2!1sen!2sin!4v1684580982079!5m2!1sen!2sin" width="510" height="350" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" className='w-full h-72'>
                </iframe>
            </div>

        </div>

        <div className='bg-white w-full p-10 md:w-[60%] flex-grow shadow-2xl'>
            <form ref={form} onSubmit={sendEmail} action="" className='flex flex-col space-y-4'>
                <div className='flex flex-col md:flex-row space-y-4 md:space-y-0 justify-center md:items-center md:space-x-4'>
                    <div className=''>
                        <label htmlFor="">Your Name</label>
                        <input type="text" placeholder='Name' name="user_name" className='border-2 border-gray-400 p-2 w-full mt-2' />
                    </div>
                    <div className=''>
                        <label htmlFor="">Your Email</label>
                        <input type="text" placeholder='Name' name="user_email" className='border-2 border-gray-400 p-2 w-full mt-2' />
                    </div>
                </div>

                <label htmlFor="">Subject</label>
                <input type="text" placeholder='Name' className='border-2 border-gray-400 p-2 w-full' />
                <label htmlFor="">Message</label>
                <textarea type="text" placeholder='Name' name='message' className='border-2 h-60 border-gray-400 p-2 w-full' />
                <div className='flex items-center justify-center mt-6'>
                    <button type='submit' value="send" className='bg-[#149ddd] hover:brightness-110 p-2 rounded-md'>Send Message</button>
                </div>
            </form> 

        </div>

      </div>
    
    </div>

  )
}